// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"3975c6aa","43":"8d336cf4","245":"1913d691","355":"8d2c5738","446":"5b48d899","492":"7d694757","928":"4f56703c","950":"e7604980"}[chunkId] + ".chunk.js";
};